import useFetchMultiChannelOrderList from './useFetchMultiChannelOrderList';
import useUpdateOrderStatus from './useUpdateOrderStatus';
import useCheckState from './useCheckState';
import useExcelDownload from './useExcelDownload';
import { Pagination, SearchOption } from '../types';
import { OrderManagementItem } from '../../../../types/multiChannel/orderManagement';

type OrderManagement = {
  totalCount: number;
  orderList: OrderManagementItem[];
  selectedCheckboxIds: string[];
  setSelectedCheckboxIds: (ids: string[]) => void;
  pagination: Pagination;
  changePagination: (pagination: Pagination) => void;
  changeSearchOption: (searchOption: SearchOption) => void;
  cancelOrders: () => void;
  returnOrders: () => void;
  readyOrders: () => void;
  downloadTotalExcel: () => void;
  downloadSelectedExcel: () => void;
};
const useOrderManagement = (): OrderManagement => {
  const { selectedCheckboxIds, setSelectedCheckboxIds, resetSelectedCheckboxIds } = useCheckState();
  const { totalCount, orderList, refetchOrderList, pagination, changePagination, searchOption, changeSearchOption } =
    useFetchMultiChannelOrderList({ resetSelectedCheckboxIds });
  const { cancelOrders, returnOrders, readyOrders } = useUpdateOrderStatus({
    orderList,
  });
  const { downloadExcelFile } = useExcelDownload({ searchOption });

  const commonResponseCallback = (): void => {
    resetSelectedCheckboxIds();
    refetchOrderList();
  };

  const handleCancelOrders = (): void => {
    cancelOrders({ ids: selectedCheckboxIds, onSuccess: commonResponseCallback, onError: commonResponseCallback });
  };

  const handleReturnOrders = (): void => {
    returnOrders({ ids: selectedCheckboxIds, onSuccess: commonResponseCallback, onError: commonResponseCallback });
  };

  const handleReadyOrders = (): void => {
    readyOrders({ ids: selectedCheckboxIds, onSuccess: commonResponseCallback, onError: commonResponseCallback });
  };

  const downloadTotalExcel = (): void => {
    downloadExcelFile({
      type: 'total',
    });
  };

  const downloadSelectedExcel = (): void => {
    downloadExcelFile({
      type: 'select',
      ids: selectedCheckboxIds,
    });
  };

  return {
    totalCount,
    orderList,
    pagination,
    selectedCheckboxIds,
    setSelectedCheckboxIds,
    changePagination,
    changeSearchOption,
    cancelOrders: handleCancelOrders,
    returnOrders: handleReturnOrders,
    readyOrders: handleReadyOrders,
    downloadTotalExcel,
    downloadSelectedExcel,
  };
};

export default useOrderManagement;
